import { ReturnRequestsFiltersProvider } from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { Outlet } from "react-router-dom";

export default function ReturnsLayout() {
  return (
    <ReturnRequestsFiltersProvider
      initialState={{
        filters: /*rawFilters ?? */ new Map(),
      }}
      onFiltersChange={
        (/*filters*/) => {
          // const params = new URLSearchParams();
          // if (filters) {
          //   params.append("filters", JSON.stringify(filters));
          // }
          //
          // setSearchParams(params, { replace: true });
        }
      }
    >
      <Outlet />
    </ReturnRequestsFiltersProvider>
  );
}
